import React from "react";
import { Container } from "../styled.ts";
import { Typography } from "../typography/index.tsx";

const Card = ({ background, description, subDescription, color, icon , subDescColor="#fff"}) => {
  return (
    <Container
      column
      alignItems="center"
      background={background}
      radius="20px"
      padding="30px"
      gap={"10px"}
    >
      <Container
        padding="10px"
        background="#fff"
        radius="20px"
        margin="0 0 20px 0"
      >
        {icon}
      </Container>
      <Typography
        tag="p"
        fontFamily="Neue Montreal"
        fontSize={"18px"}
        fontWeight={500}
        fontStyle="normal"
        lineHeight={"20.8px"}
        letterSpacing={"0.52px"}
        color={color}
        textAlign="center"
      >
        {description}
      </Typography>
      <Typography
        tag="p"
        fontFamily="Neue Montreal"
        fontSize={"12px"}
        fontWeight={400}
        lineHeight={"15px"}
        letterSpacing={"0.02em"}
        color={subDescColor}
        textAlign="center"
      >
        {subDescription}
      </Typography>
    </Container>
  );
};

export default Card;
